import { render, staticRenderFns } from "./topShareControl.vue?vue&type=template&id=668c1407&scoped=true&"
import script from "./topShareControl.vue?vue&type=script&lang=js&"
export * from "./topShareControl.vue?vue&type=script&lang=js&"
import style0 from "./topShareControl.vue?vue&type=style&index=0&id=668c1407&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668c1407",
  null
  
)

export default component.exports